module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/eyecatch-finished-1e3a3ef7b275ac24b71fc937aa11a42f.png";